<h2 class="h5">{{ 'product-specificaties-titel' | fromDictionary }}</h2>

<dl class="dl-list type-body-sm">
  @for (spec of specs; track spec.key) {
    @if (spec.type !== 'links') {
      <div class="dl-list__row">
        <dt>{{ ('product-specificatie-' + spec.key | fromDictionary: false) || (spec.key | titlecase) }}</dt>
        <dd>{{ printValue(spec) }}</dd>
      </div>
    }
    @if (spec.type === 'links' && spec?.links?.length) {
      <div class="dl-list__row">
        <dt>{{ ('product-specificatie-' + spec.key | fromDictionary: false) || (spec.key | titlecase) }}</dt>
        <dd>
          <ul class="link-list">
            @for (link of spec?.links; track link.handle; let i = $index) {
              <li class="link-list__item">
                <a [routerLink]="['/collections', link.handle]">{{ link.title + (i === (spec?.links)!.length - 1 ? '' : ',') }}</a>
              </li>
            }
          </ul>
        </dd>
      </div>
    }
  }
</dl>
